<template>
  <span>
    <slot> {{ details.carrier }}</slot>
  </span>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PhoneResolver',
  components: {},
  props: {
    phoneNumber: {
      type: [String, Number],
      default: '',
    },
    countryCode: {
      type: String,
      default: '',
    },
  },
  emits: ['carrier', 'isValid', 'details'],
  data() {
    return {
      resolutionId: '',
      details: {
        carrier: '...',
        isValid: false,
      },
      currentPhone: '',
    }
  },
  mounted() {
    this.resolve(this.phoneNumber, this.countryCode)
    setTimeout(() => {
      this.resolve(this.phoneNumber, this.countryCode)
    }, 500)
  },
  beforeUnmount() {},
  methods: {
    async resolve(phoneNumber, countryCode) {
      if (this.currentPhone !== phoneNumber) {
        this.details = { isValid: false, carrier: '...' }
        this.currentPhone = phoneNumber
      }
      if (`${phoneNumber || ''}`.length < 8) return this.details

      const resolutionId = Date.now()
      this.resolutionId = resolutionId
      const accountDetails = await this.$Events.sendDataRequestResolve(
        'resolvePhoneNumber',
        { phoneNumber, countryCode },
      )

      const carrier =
        (accountDetails.success ? accountDetails.decoded?.carrier : '') ||
        'Mauvais'
      const isValid =
        (accountDetails.success ? accountDetails.decoded?.isValid : '') || false

      const details = {
        ...(accountDetails.decoded || {}),
        isValid,
        carrier,
      }
      if (this.resolutionId === resolutionId) this.details = details
      return details
    },
  },
  watch: {
    phoneNumber: {
      handler(newValue) {
        this.resolve(newValue, this.countryCode)
      },
    },
    countryCode: {
      handler(newValue) {
        this.resolve(this.phoneNumber, newValue)
      },
    },
    details: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.$emit('carrier', newValue.carrier)
        this.$emit('isValid', newValue.isValid)
        this.$emit('details', newValue)
      },
    },
  },
  computed: {},
})
</script>
